<template>
    <div>
        <Header />
        <Breadcrumbs title="" />
        <div class="container">
            <CheckoutTitle :title=cart.address.companyname :text=cart.address.license />
            <ul>
                <li v-for="(element, index) in list" :key="index" class="account-element">
                    <router-link :to="element.link">{{ element.title }}</router-link>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>

import Header from '@/components/header';
import Breadcrumbs from '@/components/widgets/cart-breadcrumbs'
import CheckoutTitle from '@/components/widgets/cart-title';
import {mapGetters} from "vuex";

export default {
    data() {
        return {
            list: [
                { id: 1, title: "Order History", link: '/account/order-history' },
                { id: 2, title: "Rewards History", link: '/account/reward-history' },
                // { id: 3, title: "Account Settings", link: '/account/settings' }
            ],
        };
    },
    components: {
        Header,
        Breadcrumbs,
        CheckoutTitle
    },
    computed: {
      ...mapGetters({
        cart: 'cart/getCart',
      }),
    },
    methods: {

    },
    async mounted() {

    }
};
</script>
